enum TransactCampusCardAccountType {
  StoredValue = 'stored-value',
  MealPlan = 'meal-plan',
  CashEquivalency = 'cash-equivalency',
}

export { TransactCampusCardAccountType };
